import axios from "axios";
import dayjs from "dayjs";
export const getWidgetPositionStyle = (position, btn) => {
    switch (position) {
      case "Top-Left":
        return { top: "0", left: "0", transform: "translate(0, 0)" };
      case "Top-Middle":
        return { top: "0", left: "50%", transform: "translateX(-50%)" };
      case "Top-Right":
        return { top: "0", right: "0", transform: "translate(0, 0)" };
      case "Middle-Left":
        return { top: "50%", left: "0", transform: "translateY(-50%)" };
      case "Middle-Center":
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      case "Middle-Right":
        return { top: "50%", right: "0", transform: "translateY(-50%)" };
      case "Bottom-Left":
        return { bottom: "0", left: "0", transform: "translate(0, 0)" };
      case "Bottom-Middle":
        return { bottom: "0", left: "50%", transform: "translateX(-50%)" };
      case "Bottom-Right":
        return { bottom: "0", right: "0", transform: "translate(0, 0)" };
      default:
        if (btn) {
          return { bottom: "0", right: "0", transform: "translate(0, 0)" };
        } else {
          return {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          };
        }
    }
  };
export const IMG_BASE_URL=process.env.REACT_APP_API_LOCAL_IMG_URL;
export const format_Number = (num) => {
  let formattedPrice = (parseFloat(num)).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return formattedPrice.replace('.', ',');
}

export const fetchData = async ({ endpoint, method = "GET", params = {}, data = {} }) => {
  try {
      if (!endpoint) {
          throw new Error("Missing required parameter: endpoint");
      }


      const config = {
          method,
          url: endpoint,
          params: method === "GET" ? params || {} : undefined, // Attach params only for GET
          data: method !== "GET" ? data || {} : undefined,     // Attach data only for POST/PUT
      };

      const response = await axios(config);

      if (response?.status === 200 && response?.data) {
          return response.data;
      } else {
          throw new Error(`Unexpected response format or status code: ${response?.status}`);
      }
  } catch (error) {
      console.error("Error in API request:", error.response?.data || error.message || error);

      return {
          success: false,
          message: error.response?.data?.message || error.message || "Error during the API request. Please try again.",
      };
  }
};

export const validateSupplements = (
  selectedProduct,
  supplementsInfo,
  webShopProductInfo,
  setErrors,
  dispatch,
  recommededProducts,
  languageWords
) => {
  let errors = {};

  if (!Array.isArray(supplementsInfo) || supplementsInfo.length === 0) {
    dispatch(setErrors({}));
    return {};
  }

  let supplementsData =
    supplementsInfo.find(
      (s) => s.idproduct == selectedProduct?.idproduct
    )?.supplements || [];

  // if (!Array.isArray(supplementsData) || supplementsData.length === 0) {
  //   dispatch(setErrors({}));
  //   return {};
  // }

  if (
    recommededProducts &&
    webShopProductInfo?.data?.maxOneSelectedQtyForRelatedProduct &&
    supplementsData.length >= 1
  ) {
    errors.message =
      languageWords?.validationOne ||
      "You can only select one supplement for each related product";

    dispatch(setErrors(errors));
    return errors;
  }

  const supp1 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails1"
  );

  const supp2 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails2"
  );

  const supp3 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails3"
  );

  if (
    webShopProductInfo?.data?.supplementProductRequired_1 &&
    supp1.length === 0
  ) {
    errors.message =
      languageWords?.validationTwo ||
      "At least one supplement is required for Supplement 1";

    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_1 &&
    supp1.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_1
  ) {
    errors.message =
      languageWords?.validationThree ||
      "Only one supplement can be selected for Supplement 1";

    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductRequired_2 &&
    supp2.length === 0
  ) {
    errors.message =
      languageWords?.validationFour ||
      "At least one supplement is required for Supplement 2";

    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_2 &&
    supp2.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_2
  ) {
    errors.message =
      languageWords?.validationFive ||
      "Only one supplement can be selected for Supplement 2";

    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductRequired_3 &&
    supp3.length === 0
  ) {
    errors.message =
      languageWords?.validationSix ||
      "At least one supplement is required for Supplement 3";

    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_3 &&
    supp3.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_3
  ) {
    errors.message =
      languageWords?.validationSeven ||
      "Only one supplement can be selected for Supplement 3";

    dispatch(setErrors(errors));
    return errors;
  }

  dispatch(setErrors({}));
  return {};
};

// export const validateSupplements = (
//   selectedProduct,
//   supplementsInfo,
//   webShopProductInfo,
//   setErrors,
//   dispatch,
//   recommededProducts
// ) => {
//   let errors = {};
//   if (!Array.isArray(supplementsInfo) || supplementsInfo.length === 0) {
//     dispatch(setErrors({}));
//     return {};
//   }
//   let supplementsData =
//     supplementsInfo.find(
//       (s) => s.idproduct == selectedProduct?.idproduct
//     )?.supplements || [];
//   // if (!Array.isArray(supplementsData) || supplementsData.length === 0) {
//   //   dispatch(setErrors({}));
//   //   return {};
//   // }

//   if (
//     recommededProducts &&
//     webShopProductInfo?.data?.maxOneSelectedQtyForRelatedProduct &&
//     supplementsData.length >= 1
//   ) {
    
//     errors.message =
//       "You can only select one supplement for each related product";
//     dispatch(setErrors(errors));
//     return errors;
//   }
//   const supp1 = supplementsData.filter(
//     (s) => s?.detailsKey === "supplementProductsDetails1"
//   );
//   const supp2 = supplementsData.filter(
//     (s) => s?.detailsKey === "supplementProductsDetails2"
//   );
//   const supp3 = supplementsData.filter(
//     (s) => s?.detailsKey === "supplementProductsDetails3"
//   );

//   if (
//     webShopProductInfo?.data?.supplementProductRequired_1 &&
//     supp1.length === 0
//   ) {
//     errors.message = "At least one supplement is required for Supplement 1";
//     dispatch(setErrors(errors));
//     return errors;
//   }
//   if (
//     webShopProductInfo?.data?.supplementProductOnlyOneSelected_1 &&
//     supp1.length > 1 &&
//     webShopProductInfo?.data?.supplementProductRequired_1
//   ) {
//     errors.message = "Only one supplement can be selected for Supplement 1";
//     dispatch(setErrors(errors));
//     return errors;
//   }

//   if (
//     webShopProductInfo?.data?.supplementProductRequired_2 &&
//     supp2.length === 0
//   ) {
//     errors.message = "At least one supplement is required for Supplement 2";
//     dispatch(setErrors(errors));
//     return errors;
//   }
//   if (
//     webShopProductInfo?.data?.supplementProductOnlyOneSelected_2 &&
//     supp2.length > 1 &&
//     webShopProductInfo?.data?.supplementProductRequired_2
//   ) {
//     errors.message = "Only one supplement can be selected for Supplement 2";
//     dispatch(setErrors(errors));
//     return errors;
//   }

//   if (
//     webShopProductInfo?.data?.supplementProductRequired_3 &&
//     supp3.length === 0
//   ) {
//     errors.message = "At least one supplement is required for Supplement 3";
//     dispatch(setErrors(errors));
//     return errors;
//   }

//   if (
//     webShopProductInfo?.data?.supplementProductOnlyOneSelected_3 &&
//     supp3.length > 1 &&
//     webShopProductInfo?.data?.supplementProductRequired_3
//   ) {
//     errors.message = "Only one supplement can be selected for Supplement 3";
//     dispatch(setErrors(errors));
//     return errors;
//   }

//   dispatch(setErrors({}));
//   return {};
// };




export const convertToTimeFormat = (name) => {
  const regex = /price(\d+)Hour(?:s)?(?:(\d+)Minutes)?/;
  const match = name?.match(regex);

  if (match) {
    let hours = parseInt(match[1], 10) || 0;
    let minutes = match[2] ? parseInt(match[2], 10) : 0;
    const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00`;

    return formattedTime;
  }

  return "00:00:00";
};


export const calculateEndTime = (startTime, duration) => {
 
  const start = dayjs(`2024-01-01T${startTime}`);
  const [hours, minutes] = duration.split(":").map(Number);
  const end = start.add(hours, "hour").add(minutes, "minute");
  return end.format("HH:mm:ss");
};

export function timeToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function convertToMinutes(time) {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
}

export const formatName = (name,languageWords) => {
  const regex = /price(\d+)Hour(?:s)?(?:(\d+)Minutes)?/;
  const match = name.match(regex);

  if (match) {
    let hours = parseInt(match[1], 10);
    let minutes = match[2] ? parseInt(match[2], 10) : 0;

    let formattedName = `${hours} ${languageWords?.hrs}`;
    if (minutes > 0) {
      formattedName += ` ${minutes} ${languageWords?.mins}`;
    }

    return formattedName;
  }

  return name;
};
export function translateTimeValue(timeValue,languageWords) {
  const [year, month, day, hour, min] = timeValue.split('/').map(Number);
  const totalMinutes = (year * 525600) + (month * 43800) + (day * 1440) + (hour * 60) + min;
  let result = [];

  if (year > 0) result.push(`${year} ${languageWords?.year || 'year'}${year > 1 ? 's' : ''}`);
  if (month > 0) result.push(`${month} ${languageWords?.month || 'month'}${month > 1 ? 's' : ''}`);
  if (day > 0) result.push(`${day} ${languageWords?.day || 'day'}${day > 1 ? 's' : ''}`);
  if (hour > 0) result.push(`${hour} ${languageWords?.hrs}${hour > 1 ? 's' : ''}`);
  if (min > 0) result.push(`${min} ${languageWords?.mins}${min > 1 ? 's' : ''}`);
  if (result.length === 1 && min > 60) {
      let hrs = Math.floor(min / 60);
      let minsLeft = min % 60;
      return `${hrs} ${languageWords?.hrs}${hrs > 1 ? 's' : ''} ${minsLeft} ${languageWords?.mins}${minsLeft > 1 ? 's' : ''}`;
  }

  return result.join(' ');
}
export function convertToSeconds(timeValue) {
  const [year, month, day, hour, min] = timeValue.split('/').map(Number);

  const totalSeconds =
    (year * 365 * 24 * 60 * 60) +      
    (month * 30 * 24 * 60 * 60) +      
    (day * 24 * 60 * 60) +          
    (hour * 60 * 60) +               
    (min * 60);                  

  return totalSeconds;
}


export const send = (
  frameHeight,
  frameWidth,
  top,
  right,
  bottom,
  left,
  floating,
  redirectUrl
) => {
  window.parent.postMessage(
    {
      reservationIframeHeight: frameHeight,
      reservationIframeWidth: frameWidth,
      reservationIframePositionTop: top,
      reservationIframePositionRight: right,
      reservationIframePositionBottom: bottom,
      reservationIframePositionLeft: left,
      reservationIframePositionFloating: floating,
      redirectUrl: redirectUrl,
    },
    "*"
  );
};

export function calculateEndTimes(startTime, durationInSeconds) {
  let [startHours, startMinutes] = startTime?.split(":")?.map(Number);
  let totalMinutes = startHours * 60 + startMinutes + Math.floor(durationInSeconds / 60);
  let remainingSeconds = durationInSeconds % 60;
  let endHours = Math.floor(totalMinutes / 60) % 24; 
  let endMinutes = totalMinutes % 60;
  let formattedEndTime = `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`;
  return {
    endTime: formattedEndTime,
    formattedDuration: formatDuration(durationInSeconds),
  };
}

function formatDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours}h ${minutes}m ${remainingSeconds}s`;
}

export function formatTimeString(text, language) {
  console.info(language?.Hours, "language in formatTimeString")
  if (!text) return "";
  // Normalize to lower for matching
  const lower = text.toLowerCase();
  // Patterns for hour/minute in Dutch/English
  const hourPattern = /(\d+)\s*(uur|uren|hour|hours)/i;
  const minutePattern = /(\d+)\s*(minuut|minuten|min|minute|minutes)/i;

  // If both hour and minute present, convert to total minutes
  const hourMatch = lower.match(hourPattern);
  const minuteMatch = lower.match(minutePattern);
  if (hourMatch && minuteMatch) {
    const hours = parseInt(hourMatch[1], 10);
    const minutes = parseInt(minuteMatch[1], 10);
    return `${hours * 60 + minutes} ${language?.Minutes || 'min'}`;
  }
  // If only hour present
  if (hourMatch && !minuteMatch) {
    // Replace the hour unit with translation if available
    const hours = parseInt(hourMatch[1], 10);
    const hourLabel = language?.Hours || hourMatch[2];
    return `${hours} ${hourLabel}`;
  }
  // If only minute present
  if (!hourMatch && minuteMatch) {
    return text;
  }
  // Fallback to original logic for other cases
  const words = text.split(" ");
  const formattedParts = [];
  for (let i = 0; i < words.length; i += 2) {
    const num = words[i];
    const unit = words[i + 1];
    formattedParts.push(`${num} ${language?.[unit] || unit}`);
  }
  return formattedParts.join(" ");
}


export function getCompanyStatus(
  openTime,
  closeTime,
  companyOpen,
  deliveryFrom,
  deliveryTo,
  delivery,
  type,
  languageWords
) {
  if (!companyOpen && type != 'delivery') {
    return { message: languageWords?.closed || "We are closed today", color: "red", status: false };
  }

  const open = dayjs(openTime, "HH:mm:ss");
  const close = dayjs(closeTime, "HH:mm:ss");
  const deliveryStart = dayjs(deliveryFrom, "HH:mm:ss");
  const deliveryEnd = dayjs(deliveryTo, "HH:mm:ss");

  if (
    !open.isValid() ||
    !close.isValid() ||
    !deliveryStart.isValid() ||
    !deliveryEnd.isValid()
  ) {
    return { message: languageWords?.invalidTimeFormat || "Invalid time format", color: "red", status: false };
  }

  const isDeliveryWindowInOpenHours =
    deliveryStart.isBefore(close) && deliveryEnd.isAfter(open);

  if (type == 'delivery' && delivery ) {
    return {
      message: `${languageWords?.weAreOpenFrom || "We're open from"} ${deliveryStart.format("HH:mm")} ${languageWords?.to || "to"} ${deliveryEnd.format(
        "HH:mm"
      )}`,
      color: "grey",
      status: true,
    };
  }

  return {
    message: `${languageWords?.openFrom || "Open from"} ${open.format("HH:mm")} ${languageWords?.to || "to"} ${close.format("HH:mm")}`,
    color: "grey",
    status: true,
  };
}
export const extractTimes = (text) => {
  const times = text.match(/\b\d{1,2}:\d{2}\b/g) || [];
  const [fromTime, toTime] = times;

  return { fromTime, toTime };
};

